// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_DesativarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for DELETE /payments/links/desativar/{id}
 *
 * Returns a confirmation flag after the payment link is cancelled locally
 * (and best-effort cancelled in the provider).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsLinks_DesativarResponseDados {
cancelled: boolean
}

export type SubaccountsLinks_DesativarResponse = ApiResponse<SubaccountsLinks_DesativarResponseDados>;

registerResponseContract('SubaccountsLinks_DesativarResponse', {
  cancelled: { type: 'boolean', required: true },
})
